<template>
	<AppLayout :title="trans('menu.events.enrollments')">
		<Empty v-if="enrollments.length === 0"/>
		<CardGrid v-else>
			<Card v-for="enrollment in enrollments" :title="enrollment.event.title" :image="enrollment.event.image" has-image>
				<template #badges>
					<Badge :color="getEnrollmentStatusColor(enrollment.status)" active>{{ trans(`enrollments.status.${enrollment.status}.title`) }}</Badge>
					<Badge>#{{ enrollment.id }}</Badge>
				</template>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('events.enrollments.show', enrollment.id)">
						<i class="fa-solid fa-eye mr-2"/>
						{{ trans('general.view') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/Badges/Badge.vue'
import CardGrid from '@/Components/Cards/CardGrid.vue'
import {type Enrollment} from '@/Types/Events/Enrollments/Enrollment'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'
import {getEnrollmentStatusColor} from '@/Helpers/Events/Enrollments/status'

const props = defineProps<{
	enrollments:Array<Enrollment>,
}>()

const enrollments:Ref<Array<Enrollment>> = ref(props.enrollments)
</script>